module.exports = __webpack_public_path__ + "static/media/load.e2cdfcfe.svg";